import { globalConstants } from "../constants";
import { getRequest } from "../system/server-call";
import responseHandler from "../system/server-response-handler";

async function getInvoice(paymentId) {
  return getRequest(
    `/${globalConstants.VERSION}/Invoice/${paymentId}`,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

export const invoiceService = {
  getInvoice,
};
